// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1kDaZ","list":"styles_list__1Ukbs"};